import { mapState } from 'vuex'

export const mobileMixin = {
  computed: {
    ...mapState(['enableMobileOptions']),
  },
  methods: {
    changeMobileOptions() {
      if (this.enableMobileOptions) {
        this.$store.dispatch('setEnableOptions', false)
      } else {
        this.$store.dispatch('setEnableOptions', true)
      }
    },
  }
}

